import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask4300To4399Service {

  constructor() { }
}
